import type { CuratedStory, InfoDataMap } from "~types/types";

const FRANCHISE_DEFAULTS = {
    eyebrowData: {
        name: null,
        url: null,
        disableEyebrow: false,
    },
};

const FRANCHISE_INFO: InfoDataMap = {
    cryptocurrencies: {
        eyebrowData: {
            name: "Crypto",
            url: "/cryptocurrencies",
        },
    },
    cybersecurity: {
        eyebrowData: {
            name: "Cybersecurity",
            url: "/cybersecurity",
        },
    },
    hyperdrive: {
        eyebrowData: {
            name: "Hyperdrive",
            url: "/hyperdrive",
        },
    },
    "climate-changed": {
        eyebrowData: {
            name: "Climate changed",
            url: "/climate-changed",
        },
    },
    "new-economy-forum": {
        eyebrowData: {
            name: "New Economy",
            url: "/new-economy-forum",
        },
    },
    "city-of-london": {
        eyebrowData: {
            name: "City of London",
            url: "/city-of-london",
        },
    },
    "future-of-british-business": {
        eyebrowData: {
            name: "Future of British Business",
            url: "/uk-business",
        },
    },
    quicktake: {
        eyebrowData: {
            name: "QuickTake",
        },
    },
    view: {
        eyebrowData: {
            name: "Opinion",
            url: "/opinion",
        },
    },
};

export function getFranchiseEyebrowData(item: CuratedStory) {
    const franchise = item.franchise ?? "";
    const info = FRANCHISE_INFO[franchise] || {};

    return { ...FRANCHISE_DEFAULTS.eyebrowData, ...info.eyebrowData };
}
